// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"40477ab5","588":"2b7ac463"}[chunkId] + ".chunk.css";
};